import { commonViewTexts } from '../common';

const targetName = commonViewTexts.model;

export const modelListViewTexts = {
  buttons: {
    create: `${targetName}登録`,
    edit: commonViewTexts.edit,
    delete: commonViewTexts.delete
  },
  searchBarPlaceholder: `${targetName}名`,
  header: {
    name: `${targetName}名`,
    numLabels: 'ラベル数',
    status: 'ステータス',
    dateCreated: commonViewTexts.dateCreated,
    dateUpdated: commonViewTexts.dateUpdated
  }
} as const;
